import { createFileRoute } from "@tanstack/react-router";

import { ServicePageLayout } from "../components/site/ServicePageLayout";
import { ClientsMarquee } from "../components/shared/ClientsMarquee";
import { ContactForm } from "../components/home/ContactForm";
import { SeoHero } from "../components/seo/SeoHero";
import { SeoGoals } from "../components/seo/SeoGoals";
import { SeoWhy } from "../components/seo/SeoWhy";
import { SeoServices } from "../components/seo/SeoServices";
import { SeoCases } from "../components/seo/SeoCases";
import { SeoCta } from "../components/seo/SeoCta";
import { Faq } from "../components/shared/Faq";
import { buildMeta, breadcrumbJsonLd, serviceJsonLd, SITE_URL } from "../lib/site";
import { crumbTuples } from "../lib/breadcrumbs";
import { routes } from "../lib/nav";

const title = "SEO-продвижение сайтов — услуги и стоимость | HAY.agency";
const description =
  "SEO-продвижение сайтов: аудит, стратегия, техническая оптимизация, семантика, контент и регулярное сопровождение. Рассчитаем стоимость под задачи бизнеса.";

const faqItems = [
  {
    q: "Сколько стоит SEO-продвижение сайта?",
    a: "Разработка SEO-стратегии — от 120 000 ₽. Стоимость регулярного SEO-продвижения рассчитывается после аудита сайта, тематики и объёма работ. Итоговую смету фиксируем до старта.",
  },
  {
    q: "Когда появляются первые результаты?",
    a: "Первые изменения по техническим показателям и видимости обычно заметны через 2–3 месяца. Устойчивый рост органического трафика — от 6 месяцев работы.",
  },
  {
    q: "Что входит в SEO-продвижение?",
    a: "Аудит, стратегия, техническая оптимизация, семантика и структура, контент, внутренняя оптимизация, работа с внешними факторами и аналитика. Дальше — регулярное сопровождение и корректировка плана.",
  },
  {
    q: "Можно ли продвигать новый сайт?",
    a: "Да. Для нового сайта мы закладываем структуру и семантику до запуска — это ускоряет индексацию. Такой формат описан в блоке SEO при разработке сайта.",
  },
  {
    q: "Чем SEO отличается от контекстной рекламы?",
    a: "SEO даёт накопительный трафик без оплаты за клик, но требует времени. Контекстная реклама даёт заявки сразу и работает, пока есть бюджет — подробнее на странице Яндекс Директа.",
  },
];

export const Route = createFileRoute("/seo")({
  head: () => ({
    ...buildMeta({ title, description, path: "/seo", image: `${SITE_URL}/og/services/seo.webp`, imageWidth: 1200, imageHeight: 630, imageAlt: "SEO-продвижение сайтов — HAY.agency", locale: "ru_RU" }),
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": `${SITE_URL}/seo#webpage`,
              url: `${SITE_URL}/seo`,
              name: title,
              description,
              inLanguage: "ru-RU",
              isPartOf: { "@id": `${SITE_URL}/#website` },
              breadcrumb: { "@id": `${SITE_URL}/seo#breadcrumbs` },
              mainEntity: { "@id": `${SITE_URL}/seo#service` },
            },
            serviceJsonLd({
              name: "SEO-продвижение сайтов",
              description,
              path: "/seo",
              id: `${SITE_URL}/seo#service`,
              serviceType: "SEO-продвижение сайтов",
              providerId: `${SITE_URL}/#organization`,
              inGraph: true,
            }),
            breadcrumbJsonLd(crumbTuples(routes.seo), { id: `${SITE_URL}/seo#breadcrumbs`, inGraph: true }),
            {
              "@type": "FAQPage",
              "@id": `${SITE_URL}/seo#faq`,
              mainEntity: faqItems.map((item) => ({
                "@type": "Question",
                name: item.q,
                acceptedAnswer: { "@type": "Answer", text: item.a },
              })),
            },
          ],
        }),
      },
    ],
  }),
  component: Page,
});

function Page() {
  return (
    <ServicePageLayout breadcrumb="SEO продвижение" jsonLd={false}>
      <SeoHero />
      <ClientsMarquee bare />
      <SeoGoals />
      <SeoWhy />
      <SeoServices />
      <SeoCases />
      <Faq
        compact
        title="Частые вопросы о SEO-продвижении"
        lead="Стоимость, сроки, состав работ — коротко."
        items={faqItems}
      />
      <SeoCta />
      <ContactForm />
    </ServicePageLayout>
  );
}
